import { Fragment } from 'react';
import { Button, Link } from '@flos/react-ui';
import WizardPagetemplate from '../../templates/WizardPagetemplate';
import { useRecoilValue } from 'recoil';
import type { RowInformation } from '../../config/flavourConfig';
import AdjustableItem from './components/AdjustableItem';
import { currentCoverableSelector } from '../../recoil/selectors/currentCoverableSelector';
import { useHippoText } from '../../hooks/useHippoText';
import type { WizardPageComponent } from '../../config/wizardPagesConfig';
import useWizardNavigation from '../../hooks/useWizardNavigation';
import getCoverableAdjustDetailsConfig from './config/adjustDetails';
import { businessFlowSelector } from '../../recoil/selectors/getBusinessFlowSelector';
import { coverableChangesAtom } from '../../recoil/atoms/coverableChangesAtom';

const AdjustDetailsPage: WizardPageComponent = () => {
    const { wizardGotoStep } = useWizardNavigation();
    const coverable = useRecoilValue(currentCoverableSelector);
    const getHippoText = useHippoText();
    const hippoText = {
        pageTitle: getHippoText('DSS-SHOPPING-BASKET-ADJUST-DETAILS-TITLE'),
        backButton: getHippoText('DSS-COMMON-BACK')
    };
    const businessFlow = useRecoilValue(businessFlowSelector);
    const coverableChanges = useRecoilValue(coverableChangesAtom);

    if (coverable === undefined) return <></>;

    const adjustableItemsInfo = getCoverableAdjustDetailsConfig(
        coverable,
        getHippoText,
        businessFlow,
        coverableChanges
    );

    return (
        <WizardPagetemplate hidePrevious hideNext showGiftCertificateBanner={false}>
            <div>
                <div className="u-flex-box u-flex-box--center u-flex-justify-strech u-gap-3 u-spacing-stack-l">
                    <Button
                        theme="secondary"
                        size="medium"
                        iconShape="arrow-left"
                        onClick={() => {
                            wizardGotoStep('ShoppingBasketPage');
                        }}
                    />
                    <Link
                        className="u-color-primary-2-dark"
                        onClick={() => {
                            wizardGotoStep('ShoppingBasketPage');
                        }}
                    >
                        {hippoText.backButton}
                    </Link>
                </div>
                <div className="u-spacing-stack-m">
                    <h3 id="adjust-details-title">{hippoText.pageTitle}</h3>
                    {adjustableItemsInfo?.map((rowInfo: RowInformation) => {
                        const isRowHidden = rowInfo.hidden ?? false;

                        if (isRowHidden) {
                            return <Fragment key={rowInfo.name} />;
                        }

                        return <AdjustableItem key={rowInfo.name} rowInfo={rowInfo} />;
                    })}
                </div>
            </div>
        </WizardPagetemplate>
    );
};

export default AdjustDetailsPage;
